export enum ImportType {
    Payment = 1,
    Property = 2,
    RentalUnit = 3,
    Tenant = 4,
    AssociationOwner = 5,
    Rentalowner = 6,
    HOAUnit = 7,
    SingleUnitProperty = 8,
    Vendor = 9,
    PaymentAndCharge = 10,
    CheckAndDeposit = 11,
    OpeningBankAccountBalance = 12,
    OpeningBalanceChargesAndCredits = 13,
    Rentals = 14,
    Associations = 15,
    StrongroomPayments = 16,
    Bills = 17,
    UnpaidBills = 18,
    FutureRent = 19,
    ChartOfAccounts = 20,
    EditChartOfAccounts = 21,
    AddChartOfAccounts = 22,
    AABAssociationIds = 23,
    AABMemberIds = 24,
    FCBAssociationIds = 25,
    FCBAccountIds = 26,
    CustomFieldRentals = 27,
    CustomFieldRentalUnits = 28,
    CustomFieldAssociations = 29,
    CustomFieldAssociationUnits = 30,
    CustomFieldAssociationOwners = 32,
    CustomFieldAssociationTenants =33,
    RentalOwnersNew = 34,
    OpeningBalanceChargesAndCreditsNew = 35,
    AssociationOwnersAndTenants = 36,
    CustomFieldVendors =37,
    TenantNew = 38,
    CustomFieldRentalOwners = 39,
    CustomFieldLeases = 40,
    CustomFieldOwnershipAccounts = 41
}
